import React from "react";

import ImportarNcm from "components/ImportarNcm";

const ImportarNcmPage = () => <ImportarNcm />;

export default ImportarNcmPage;

